import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1690991114897-7dc74a822372?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHx0ZWNobm8lMjBjbHViJTIwY3Jvd2QlMjBkYXJrfGVufDB8fHx8MTc3ODQ5ODE2OXww&ixlib=rb-4.1.0&q=85",
    alt: "Club crowd under industrial lighting",
    span: "col-span-12 md:col-span-7 row-span-2 aspect-[4/3] md:aspect-auto",
    tag: "Live · Berlin",
  },
  {
    src: "https://images.unsplash.com/photo-1561356476-ce439955d3f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxkaiUyMHR1cm50YWJsZSUyMHZpbnlsJTIwZGFyayUyMG1pbmltYWx8ZW58MHx8fHwxNzc4NDk4MTg5fDA&ixlib=rb-4.1.0&q=85",
    alt: "Turntable close-up",
    span: "col-span-6 md:col-span-5 aspect-square",
    tag: "Studio",
  },
  {
    src: "https://images.unsplash.com/photo-1759338245039-906f7558e743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhcmslMjBtaW5pbWFsJTIwdGV4dHVyZXxlbnwwfHx8fDE3Nzg0MTA4ODR8MA&ixlib=rb-4.1.0&q=85",
    alt: "Metallic texture",
    span: "col-span-6 md:col-span-3 aspect-square",
    tag: "Texture",
  },
  {
    src: "https://images.unsplash.com/photo-1701705319364-ec5468034cf6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxkaiUyMHBsYXlpbmclMjBsaXZlJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc3ODQ5ODE3MHww&ixlib=rb-4.1.0&q=85",
    alt: "DJ playing live",
    span: "col-span-12 md:col-span-2 aspect-square md:aspect-auto",
    tag: "Booth",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 sm:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="font-mono text-xs tracking-[0.3em] uppercase text-[#FF2A2A]">
              [ 04 / Visuals ]
            </span>
            <h2 className="mt-4 font-heading font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.9]">
              From the
              <br />
              Smoke Room
            </h2>
          </div>
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#8A8A8A] max-w-xs">
            ↳ Shot by friends. No filters. Mostly bad lighting on purpose.
          </p>
        </Reveal>

        <div className="grid grid-cols-12 gap-3 sm:gap-4">
          {IMAGES.map((img, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.05 }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`gallery-item-${i}`}
              className={`relative group overflow-hidden border border-white/5 ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700 scale-105 group-hover:scale-100"
              />
              <figcaption className="absolute bottom-3 left-3 font-mono text-[10px] tracking-[0.2em] uppercase bg-[#050505]/70 px-2 py-1 border border-white/10">
                {img.tag}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
